import { useState } from 'react';
import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <nav className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" aria-label="韩漫网首页">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-line text-lg"></i>
          </div>
          <span className="text-lg font-heading font-bold text-foreground-900 whitespace-nowrap">
            {siteInfo.name}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
            首页
          </Link>
          <Link to="/category/romance" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
            分类
          </Link>
          <Link to="/category/fantasy" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
            热门
          </Link>
          <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-48 h-9 pl-9 pr-3 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2" onClick={() => setMobileOpen(false)}>
            首页
          </Link>
          <Link to="/category/romance" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2" onClick={() => setMobileOpen(false)}>
            分类浏览
          </Link>
          <Link to="/category/fantasy" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2" onClick={() => setMobileOpen(false)}>
            热门漫画
          </Link>
          <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2" onClick={() => setMobileOpen(false)}>
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}